/*
 *  I15DIMSILOBOISCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-19 13:57:08 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { fetchDegreJourUnifie, fetchDataMaterial, fetchSiloBoisDuration } from '@batical/data/src'
import { I15DIMSILOBOIS_State } from '@batical/types/src'
import { setMonth, format, getDaysInMonth } from 'date-fns'
import { fr } from 'date-fns/locale'
import { chain } from 'mathjs'

function I15DIMSILOBOIS_docalcul(state: I15DIMSILOBOIS_State) {
  const {
    in_renderement_install_bois,
    in_puissance_nominale_chaudiere,
    dju_uuid,
    material_uuid,
    in_temp_consigne,
    in_deperdition,
    in_tempExtBase,
    in_masse_volumique,
    duration_uuid
  } = state
  let dju = fetchDegreJourUnifie(dju_uuid)
  let selectedmaterial_uuid = fetchDataMaterial(material_uuid)
  let selectedduration = fetchSiloBoisDuration(duration_uuid)

  state.res_pci_combu = selectedmaterial_uuid.pci_mini / in_masse_volumique
  const dataChart: Array<{ mois: string; volume: number; bois: number; taux: number }> = []
  const diffTemp = chain(in_temp_consigne).subtract(in_tempExtBase).done()
  const besonBaseFixe = chain(24).multiply(in_deperdition).divide(diffTemp).divide(0.8).done()
  // const besonBaseFixe = (24 * in_deperdition) / (in_temp_consigne - in_tempExtBase) / 0.8
  const fixValue = chain(selectedmaterial_uuid.pci_mini).multiply(in_renderement_install_bois).divide(100).done()

  for (let i = 1; i <= 12; i++) {
    const monthFormat = format(setMonth(new Date(), i - 1), 'LLL', { locale: fr })
    let pushing = { mois: monthFormat, volume: 0, bois: 0, taux: 0 }
    if (dju && fixValue !== 0) {
      //@ts-expect-error flemme de typer
      const djuSelected = dju[`m${i}`]

      if (!isNaN(djuSelected)) {
        const produBoisPossible = in_puissance_nominale_chaudiere * 24 * getDaysInMonth(setMonth(new Date(), i - 1))
        const bois = Math.min(produBoisPossible, besonBaseFixe * djuSelected)
        const vol = Math.round(((besonBaseFixe * djuSelected) / fixValue) * 100000) / 100000
        pushing = {
          mois: monthFormat,
          volume: vol,
          bois: bois,
          taux: bois !== 0 ? Math.round((bois / (besonBaseFixe * djuSelected)) * 100) : 0
        }
      }
    }
    dataChart.push(pushing)
  }

  const volueMoyenUtil = chain(besonBaseFixe).multiply(dju.average).divide(fixValue).multiply(selectedduration.ratio).done()

  state.res_volume_moyen = volueMoyenUtil
  state.res_silo_rotatif = volueMoyenUtil + volueMoyenUtil * 0.3 + volueMoyenUtil * 0.25
  state.res_silo_racleur = volueMoyenUtil + volueMoyenUtil * 0.2 + volueMoyenUtil * 0.25
  state.res_silo_cylindrique = volueMoyenUtil + volueMoyenUtil * 0.25
  state.dataChart = dataChart

  return state
}

export default I15DIMSILOBOIS_docalcul
